import localStorage from '@/utils/localStorage';
import * as service from './service';

import { isAlipay } from '@/utils/browser';

const services = { ...service };

const state = {
  cityList: [],
  location: {},
  locationCity: {},
  city: {},
  showCityList: false,
};

const mutations = {
  setCityList(state, list) {
    state.cityList = list;
  },
  setLocation(state, obj) {
    state.location = obj;
  },
  setLocationCity(state, obj) {
    state.locationCity = obj;
  },
  setCity(state, obj) {
    state.city = obj;
  },
  setShowCityList(state, bool) {
    state.showCityList = bool;
  },
};

const actions = {
  // 事件
  async getCityGeolocation({ dispatch }) {
    await Promise.all([dispatch('getCityList'), dispatch('geolocation')]);
    dispatch('findCity');
  },
  changeShowCityList({ commit, state }, bool) {
    const showCityList = bool ?? !state.showCityList;
    commit('setShowCityList', showCityList);
  },
  clickCity({ commit, dispatch }, city) {
    commit('setCity', city);
    dispatch('changeShowCityList', false);
  },
  // 步骤
  getCityList({ commit }) {
    const localCityList = localStorage.get('cityList');
    if (localCityList) {
      commit('setCityList', localCityList);
      return;
    }
    return services.getCityList().then((res) => {
      const cityList = res.data;
      localStorage.set('cityList', cityList);
      commit('setCityList', cityList);
    });
  },
  async geolocation({ commit, dispatch }) {
    let data = {};
    if (process.env.VUE_APP_ENV === 'development') {
      data = {
        adCode: '440100',
        province: '广东省',
        city: '广州市',
        longitude: '113.415005',
        latitude: '23.175488',
      };
    } else {
      try {
        if (window.isMiniprogram) {
          data = await dispatch('miniGeolocation');
        } else if (isAlipay) {
          data = await dispatch('alipayGeolocation');
        } else {
          data = await dispatch('qqGeolocation');
        }
      } catch (error) {
        data = await dispatch('ipGeolocation');
      }
    }
    // 拼合经纬度
    data.position = `${data.longitude},${data.latitude}`;
    // 判断直辖市
    const provinceList = ['北京市', '天津市', '上海市', '重庆市'];
    const index = provinceList.findIndex((item) => {
      return item.indexOf(data.province) > -1;
    });
    if (index > -1) {
      data.city = provinceList[index];
    }
    commit('setLocation', data);
    return data;
  },
  miniGeolocation() {
    return new Promise((resolve, reject) => {
      my.getLocation({
        type: 1,
        success: (res) => {
          const data = {
            adCode: res.adCode,
            province: res.province,
            city: res.city,
            longitude: res.longitude,
            latitude: res.latitude,
          };
          resolve(data);
        },
        fail(error) {
          reject(error);
        },
      });
    });
  },
  alipayGeolocation() {
    return ap.getLocation({ type: 1 }).then((res) => {
      const data = {
        adCode: res.adCode,
        province: res.province,
        city: res.city,
        longitude: res.longitude,
        latitude: res.latitude,
      };
      return data;
    });
  },
  qqGeolocation() {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js';
      script.onload = () => {
        const geolocation = new qq.maps.Geolocation('5HZBZ-U2IK3-HVY3H-YVOKC-AKX3Q-XGFBU', 'h5');
        geolocation.getLocation(
          (res) => {
            const data = {
              adCode: res.adcode.toString(),
              province: res.province,
              city: res.city,
              longitude: res.lng.toString(),
              latitude: res.lat.toString(),
            };
            resolve(data);
          },
          (error) => {
            reject(error);
          }
        );
      };
      document.head.appendChild(script);
    });
  },
  ipGeolocation() {
    return services
      .ipGeolocation()
      .then((res) => {
        const data = {
          adcode: res.adcode,
          province: res.province,
          city: res.city,
          longitude: res.rectangle.split(';')[0].split(',')[0],
          latitude: res.rectangle.split(';')[0].split(',')[1],
        };
        return data;
      })
      .catch(() => {
        return {};
      });
  },
  findCity({ commit, state }) {
    const cityList = state.cityList;
    const location = state.location;
    let city = cityList[0].cities[0];
    if (location.city) {
      for (let i = 0; i < cityList.length; i++) {
        const index = cityList[i].cities.findIndex((item) => {
          return location.city.indexOf(item.name) > -1;
        });
        if (index > -1) {
          city = cityList[i].cities[index];
        }
      }
    }
    commit('setLocationCity', city);
    commit('setCity', city);
  },
};

export default {
  namespaced: true,
  services,
  state,
  mutations,
  actions,
};
